module.exports = __webpack_public_path__ + "static/charo-30a1d84f77c5b4001ee2943d75f30138.png";